import * as FlashMessage from "../../shared/utils/flashMessage"
import { SUCCESS } from "../../shared/constants/messages.constants"
import CONFIG from "../../config"
import { updateActiveAssessment } from "../../actions/assessment.action"

export const onAssessmentComplete = (assessment = {}) => {
    FlashMessage.success(SUCCESS.ASSESSMENT_SUCCESSFULLY_COMPLETED)

    CONFIG.Store.dispatch(updateActiveAssessment(assessment.id,{ status: assessment.status }))
}